<div class="workflow-container">
    <div class="stages-list-wrapper">
        <div class="stages-list neo-scrollbar" cdkDropList (cdkDropListDropped)="onStageDrop($event)"
            cdkDropListAutoScrollStep="5">
            <div class="stage stage-option {{ stage.isActive ? 'active' : '' }} {{ !canDragStage(stage) ? 'drag-disabled' : '' }}"
                *ngFor="let stage of stages;let stageIndex = index" cdkDrag [cdkDragDisabled]="!canDragStage(stage)"
                (click)="!isDragMode && openStage(stage.id)" (keydown.enter)="!isDragMode && openStage(stage.id)">

                <div class="drag-handle-icon" *ngIf="canDragStage(stage)">
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2" cy="2.5" r="1" fill="#9CA3AF" />
                        <circle cx="2" cy="6" r="1" fill="#9CA3AF" />
                        <circle cx="2" cy="9.5" r="1" fill="#9CA3AF" />
                        <circle cx="6" cy="2.5" r="1" fill="#9CA3AF" />
                        <circle cx="6" cy="6" r="1" fill="#9CA3AF" />
                        <circle cx="6" cy="9.5" r="1" fill="#9CA3AF" />
                    </svg>
                </div>

                <div *ngIf="!stage.isRenameStage" class="stage-content-wrapper"
                    [pTooltip]="stage.candidate_count ? 'Total Candidates : ' + stage.candidate_count : ''"
                    tooltipPosition="right" [showDelay]="100" [hideDelay]="0">
                    <span class="stage-name">{{ stage.name }}</span>
                </div>

                <div *ngIf="stage.isRenameStage" class="rename-stage-wrapper">
                    <input type="text" pInputText class="rename-stage-input" placeholder="Rename"
                        [(ngModel)]="stageRename" (keyup.enter)="renameStage(stage)"
                        (keyup.escape)="stage.isRenameStage = false;">
                    <div class="rename-actions">
                        <em class="pi pi-check rename-action-icon" (click)="renameStage(stage)"
                            (keydown.enter)="renameStage(stage)" title="Save"></em>
                        <em class="pi pi-times rename-action-icon" (click)="stage.isRenameStage = false;"
                            (keydown.enter)="stage.isRenameStage = false;" title="Cancel"></em>
                    </div>
                </div>

                <div *ngIf="!stage.isRenameStage" class="stage-tag-group">
                    <span class="stage-type-tag" [ngClass]="getStageTypeClass(stage.type)">
                        <em *ngIf="stage.is_walk_in" class="pi pi-map-marker stage-walkin-icon"
                            pTooltip="Walk-in mode" tooltipPosition="top"></em>
                        {{ stage.type | uppercase }}
                    </span>
                </div>

                <em class="pi pi-ellipsis-v stageOptions"
                    [style]="{display: (stage.isActive && !isDragMode && !stage.isRenameStage) ? 'block' : 'none'}"
                    (click)="!isDragMode && options_op.toggle($event)"
                    (keydown.enter)="!isDragMode && options_op.toggle($event)"></em>

                <p-popover #options_op styleClass="no-padding-overlay">
                    <ng-template #content>
                        <p *ngIf="userPrivileges.has('event_stage.delete') && stageIndex >= 1"
                            class="stageOptions-overlay" [ngClass]="{'disabled': !stage.deletable}"
                            (click)="deleteStage(stage.id, $event)" (keydown.enter)="deleteStage(stage.id, $event)">
                            Delete
                        </p>
                        <p *ngIf="userPrivileges.has('event_stage.create')" class="stageOptions-overlay"
                            (click)="duplicateStage(stage, options_op)"
                            (keydown.enter)="duplicateStage(stage, options_op)">
                            Duplicate
                        </p>
                        <p *ngIf="userPrivileges.has('event_stage.update')" class="stageOptions-overlay"
                            (click)="stage.isRenameStage = true; stageRename = stage.name; options_op.hide()"
                            (keydown.enter)="stage.isRenameStage = true; stageRename = stage.name; options_op.hide()">
                            Rename
                        </p>
                    </ng-template>
                </p-popover>

                <!-- Custom Drag Preview -->
                <div *cdkDragPreview class="stage-drag-preview">
                    <div class="drag-preview-content">
                        <div class="drag-handle-icon">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2" cy="2.5" r="1" fill="#9CA3AF" />
                                <circle cx="2" cy="6" r="1" fill="#9CA3AF" />
                                <circle cx="2" cy="9.5" r="1" fill="#9CA3AF" />
                                <circle cx="6" cy="2.5" r="1" fill="#9CA3AF" />
                                <circle cx="6" cy="6" r="1" fill="#9CA3AF" />
                                <circle cx="6" cy="9.5" r="1" fill="#9CA3AF" />
                            </svg>
                        </div>
                        <span class="stage-name">{{ stage.name }}</span>
                        <span class="stage-type-tag" [ngClass]="getStageTypeClass(stage.type)">
                            {{ stage.type | uppercase }}
                        </span>
                    </div>
                </div>

                <!-- Drag Placeholder -->
                <div *cdkDragPlaceholder class="stage-drag-placeholder"></div>
            </div>
        </div>

        <!-- Save/Cancel Buttons -->
        <div class="reorder-actions" *ngIf="isDragMode">
            <button pButton type="button" class="cancel-order-btn" (click)="cancelDragMode()"
                [disabled]="isSavingReorder">
                <span>Cancel</span>
            </button>
            <button pButton type="button" class="save-order-btn" [loading]="isSavingReorder" (click)="saveStageOrder()"
                [disabled]="isSavingReorder">
                <span>Save</span>
            </button>
        </div>
    </div>
    <div class="stages-container">
        <p-dialog [(visible)]="displayAddStage" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
            styleClass="neo-dialog" [style]="{width: '60vw', maxWidth: '800px', minWidth: '600px'}"
            (onHide)="closeAddStage()">

            <div class="dialog-wrapper">
                <div class="dialog-header">
                    <h2 class="dialog-title">{{ currentDialogStep === 1 ? 'Add Stage' : 'Manage ' + selectedType }}</h2>
                    <button class="dialog-close-btn" (click)="closeAddStage()">
                        <em class="pi pi-times"></em>
                    </button>
                </div>

                    <div class="dialog-content">
                        <div class="content-wrapper">
                            <div *ngIf="currentDialogStep === 1" class="content">
                                <div class="section">
                                    <h3 class="section-heading">Please Select The Type Of Stage You Would Like To Add </h3>
                                    <div class="section-content" *ngIf="!isLoading">
                                        <div class="radio-group" *ngFor="let category of stageTypes">
                                            <p-radioButton 
                                                [inputId]="category" 
                                                name="category" 
                                                [value]="category"
                                                [(ngModel)]="selectedType" 
                                                (ngModelChange)="onCategoryChange()">
                                            </p-radioButton>
                                            <label class="radio-label" [for]="category">{{ category }}</label>
                                        </div>
                                    </div>
                                    <div class="section-content section-loading" *ngIf="isLoading">
                                        <p-progressSpinner [style]="{height: '50px', width: '50px'}" strokeWidth="2" animationDuration="0.5s"></p-progressSpinner>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="currentDialogStep === 2" class="content">
                                <div class="section">
                                    <div class="section-content">
                                        <div class="form-field neo-input-wrapper">
                                            <label class="field-label">Stage Name<span class="required-asterisk">*</span></label>
                                            <input 
                                                bigger
                                                type="text" 
                                                class="form-input" 
                                                [(ngModel)]="stageName"
                                                placeholder="Enter stage name"
                                                (keyup.enter)="createStage()">
                                        </div>

                                        <div class="form-field neo-input-wrapper" *ngIf="selectedType === 'Documentation'">
                                            <label class="field-label">Documentation Form<span class="required-asterisk">*</span></label>
                                            <p-select 
                                                bigger
                                                class="form-dropdown feedback-form-selection"
                                                [options]="documentationForms" 
                                                optionLabel="label" 
                                                optionValue="value" 
                                                [(ngModel)]="selectedForm" 
                                                [showClear]="!!selectedForm && selectedForm !== ''"
                                                #documentFormEl
                                                [panelStyle]="{
                                                    'min-width': documentFormEl.el.nativeElement.offsetWidth + 'px',
                                                    'max-width': documentFormEl.el.nativeElement.offsetWidth + 'px'
                                                }"
                                                appendTo="body"
                                                placeholder="Select Documentation Form">
                                            </p-select>
                                        </div>

                                        <div class="form-field neo-input-wrapper" *ngIf="selectedType === 'Online Interview' || selectedType === 'Offline Interview' || selectedType === 'AI Interview'">
                                            <label class="field-label">Feedback Form<span class="required-asterisk" *ngIf="selectedType !== 'AI Interview'">*</span></label>
                                            <p-select 
                                                bigger
                                                class="form-dropdown feedback-form-selection"
                                                [options]="feedbackForms" 
                                                optionLabel="label" 
                                                optionValue="value" 
                                                [(ngModel)]="selectedForm" 
                                                [showClear]="!!selectedForm && selectedForm !== ''"
                                                appendTo="body"
                                                #selectedFormEl
                                                [panelStyle]="{
                                                    'min-width': selectedFormEl.el.nativeElement.offsetWidth + 'px',
                                                    'max-width': selectedFormEl.el.nativeElement.offsetWidth + 'px'
                                                }"
                                                placeholder="Select Feedback Form">
                                            </p-select>
                                        </div>

                                        <div class="form-field neo-input-wrapper" *ngIf="selectedType === 'Assessment'">
                                            <div class="walkin-toggle-card" [class.active]="isWalkIn">
                                                <div class="walkin-toggle-icon"><em class="pi pi-map-marker"></em></div>
                                                <div class="walkin-toggle-text">
                                                    <span class="walkin-toggle-title">Walk-in mode</span>
                                                    <span class="walkin-toggle-hint">Candidates launch this assessment at a venue using a shared link + access key instead of an individual email link + OTP.</span>
                                                </div>
                                                <p-toggleswitch [(ngModel)]="isWalkIn"></p-toggleswitch>
                                            </div>
                                        </div>

                                        <div class="form-field neo-input-wrapper" *ngIf="selectedType === 'Assessment'">
                                            <label class="field-label">Test Source<span class="required-asterisk">*</span> <span class="course-test-label">(Course - Test)</span></label>
                                            <p-select
                                                bigger
                                                class="form-dropdown"
                                                [options]="testForms"
                                                optionLabel="label"
                                                optionValue="value"
                                                [(ngModel)]="selectedForm"
                                                [showClear]="!!selectedForm && selectedForm !== ''"
                                                [filter]="true"
                                                filterBy="label"
                                                appendTo="body"
                                                #assessmentFormEl
                                                [panelStyle]="{
                                                    'min-width': assessmentFormEl.el.nativeElement.offsetWidth + 'px',
                                                    'max-width': assessmentFormEl.el.nativeElement.offsetWidth + 'px'
                                                }"
                                                placeholder="Select Test">
                                                <ng-template let-item pTemplate="item">
                                                    <div class="contest-dropdown-item">
                                                        <span>{{ item.label }}</span>
                                                        <span *ngIf="item.test_start_date" class="test-start-date-badge">
                                                            {{ formatTestStartDate(item.test_start_date) }}
                                                        </span>
                                                    </div>
                                                </ng-template>
                                            </p-select>
                                        </div>

                                        <div class="form-field neo-input-wrapper" *ngIf="selectedType === 'Offer'">
                                            <label class="field-label">Offer Form<span class="required-asterisk">*</span></label>
                                            <p-select 
                                                bigger
                                                class="form-dropdown feedback-form-selection"
                                                [options]="offerForms" 
                                                optionLabel="label" 
                                                optionValue="value" 
                                                appendTo="body"
                                                #ms
                                                [panelStyle]="{
                                                    'min-width': ms.el.nativeElement.offsetWidth + 'px',
                                                    'max-width': ms.el.nativeElement.offsetWidth + 'px'
                                                }"
                                                [(ngModel)]="selectedForm" 
                                                [showClear]="!!selectedForm && selectedForm !== ''"
                                                placeholder="Select Offer Form">
                                            </p-select>
                                        </div>

                                    <!-- Agent dropdown for AI Interview -->
                                    <div class="form-field neo-input-wrapper" *ngIf="selectedType === 'AI Interview'">
                                        <label class="field-label">Agent<span class="required-asterisk">*</span></label>
                                        <p-select 
                                            bigger
                                            class="form-dropdown" 
                                            [options]="agents" 
                                            optionLabel="label"
                                            optionValue="value" 
                                            [(ngModel)]="selectedAgent"
                                            [showClear]="!!selectedAgent && selectedAgent !== ''"
                                            appendTo="body" 
                                            placeholder="Select Agent">
                                        </p-select>
                                    </div>

                                    <!-- Evaluation Criteria for Interview types -->
                                    <div class="form-field neo-input-wrapper"
                                        *ngIf="selectedType === 'AI Interview' || selectedType === 'Online Interview' || selectedType === 'Offline Interview'">
                                        <label class="field-label">
                                            Evaluation Criteria
                                            <span class="required-asterisk"
                                                *ngIf="selectedType === 'AI Interview'">*</span>
                                        </label>
                                        <textarea pInputTextarea class="form-input" [(ngModel)]="evaluationCriteria"
                                            placeholder="Enter evaluation criteria for this interview stage..." rows="4"
                                            maxlength="1000" style="resize: vertical; min-height: 80px;">
                                        </textarea>
                                        <small class="character-counter"
                                            [ngClass]="{'text-danger': evaluationCriteria.length >= 1000}">
                                            {{ evaluationCriteria.length }} / 1000 characters
                                        </small>

                                        <!-- Sample Evaluation Criteria collapsible -->
                                        <div class="sample-criteria-panel">
                                            <div class="sample-criteria-header" (click)="toggleSampleCriteria()" role="button" tabindex="0" [attr.aria-expanded]="sampleCriteriaExpanded" (keydown.enter)="toggleSampleCriteria()" (keydown.space)="toggleSampleCriteria(); $event.preventDefault()">
                                                <div class="sample-criteria-header-left">
                                                    <span class="sample-spark-dot"></span>
                                                    <span class="sample-criteria-title">Sample Evaluation Criteria</span>
                                                    <span class="sample-role-chip">React Developer</span>
                                                </div>
                                                <div class="sample-criteria-header-right">
                                                    <button class="sample-copy-btn"
                                                        type="button"
                                                        (click)="copySampleCriteria($event)"
                                                        (keydown.enter)="copySampleCriteria($event)"
                                                        (keydown.space)="copySampleCriteria($event)"
                                                        [title]="copiedSample ? 'Copied to clipboard!' : 'Copy to clipboard'"
                                                        aria-label="Copy sample criteria">
                                                        <svg *ngIf="!copiedSample" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="8" y="8" width="13" height="13" rx="2" stroke="#7C5CDB" stroke-width="1.8" fill="none"/>
                                                            <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="#7C5CDB" stroke-width="1.8" stroke-linecap="round" fill="none"/>
                                                        </svg>
                                                        <svg *ngIf="copiedSample" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M20 6L9 17l-5-5" stroke="#16a34a" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </button>
                                                    <em class="pi sample-chevron"
                                                        [class.pi-chevron-down]="!sampleCriteriaExpanded"
                                                        [class.pi-chevron-up]="sampleCriteriaExpanded"></em>
                                                </div>
                                            </div>
                                            <div class="sample-criteria-body" [class.expanded]="sampleCriteriaExpanded">
                                                <div class="sample-criteria-content">
                                                    <div class="sample-tips-wrapper">
                                                        <div class="sample-duration-tip" *ngIf="selectedType === 'AI Interview'">
                                                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0;margin-top:1px">
                                                                <circle cx="12" cy="12" r="10" stroke="#94A3B8" stroke-width="1.8"/>
                                                                <path d="M12 8v4m0 4h.01" stroke="#94A3B8" stroke-width="2" stroke-linecap="round"/>
                                                            </svg>
                                                            <span>List only skills that can be covered within your interview duration.</span>
                                                        </div>
                                                        <div class="sample-duration-tip">
                                                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0;margin-top:1px">
                                                                <circle cx="12" cy="12" r="10" stroke="#94A3B8" stroke-width="1.8"/>
                                                                <path d="M12 8v4m0 4h.01" stroke="#94A3B8" stroke-width="2" stroke-linecap="round"/>
                                                            </svg>
                                                            <span>Clearly mention skills that you want to evaluate.</span>
                                                        </div>
                                                    </div>
                                                    <div class="sample-bullet" *ngFor="let s of SAMPLE_CRITERIA_SECTIONS">
                                                        <span class="sample-bullet-dot"></span>
                                                        <span class="sample-bullet-text">{{ s }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                        <div class="form-field neo-input-wrapper" *ngIf="(selectedType === 'Documentation' || selectedType === 'Assessment' || selectedType === 'Online Interview' || selectedType === 'Offer' || selectedType === 'Offline Interview' || selectedType === 'AI Interview') && !(selectedType === 'Assessment' && isWalkIn)">
                                            <label class="field-label">
                                                Email Template<span class="required-asterisk">*</span>
                                            </label>
                                            <p-select 
                                                bigger
                                                class="form-dropdown"
                                                appendTo="body"
                                                #docFormEl
                                                [panelStyle]="{
                                                    'min-width': docFormEl.el.nativeElement.offsetWidth + 'px',
                                                    'max-width': docFormEl.el.nativeElement.offsetWidth + 'px'
                                                }"
                                                [options]="templateOptions"
                                                optionLabel="name" 
                                                [(ngModel)]="selectedMailTemplateId" 
                                                filterBy="name" 
                                                [filter]="true"  
                                                (onChange)="getSelectedMailTemplate(selectedMailTemplateId)" 
                                                placeholder="Select Email Template">
                                            </p-select>

                                        <div class="error-message" *ngIf="errorPlaceholder.length">
                                            Please select another template with the following placeholder:
                                            <div *ngFor="let data of errorPlaceholder; let i = index">
                                                <span>{{i+1}}. {{data}}</span>
                                            </div>
                                        </div>

                                        <div class="email-template-preview"
                                            *ngIf="selectedMailTemplate?.templateContent">
                                            <div class="preview-header">Email Preview</div>
                                            <div class="preview-content"
                                                [innerHTML]="selectedMailTemplate?.templateContent | getSafeHTMLEmail">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dialog-footer-compact">
                    <div class="dialog-action-left">
                        <button *ngIf="currentDialogStep === 2" pButton pRipple type="button" class="change-stage-btn"
                            (click)="goToStep(1)" style="
                                background-color: transparent;
                                color: #64748b;
                                border: 1px solid;
                                ">
                            <em class="pi pi-arrow-left" style="margin-right: 8px;"></em>
                            Change Stage Type
                        </button>
                    </div>

                    <div class="dialog-action-right">
                        <button *ngIf="currentDialogStep === 1" pButton pRipple type="button" class="create-btn"
                            [disabled]="!selectedType || isLoading" (click)="goToStep(2)">
                            Next
                        </button>

                        <button *ngIf="currentDialogStep === 2" pButton pRipple type="button" class="create-btn"
                            [disabled]="!selectedType || !stageName || (!isTemplateValidated && !(selectedType === 'Assessment' && isWalkIn)) || isSaveClicked || (selectedType === 'AI Interview' && (!evaluationCriteria || evaluationCriteria.trim().length === 0))"
                            [loading]="isSaveClicked" (click)="createStage()">
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </p-dialog>

        <ng-content *ngFor="let stage of stages">
            <div class="stageDetails" *ngIf="stage.isActive">
                <div class="header-tab_search">
                    <div class="selected-stage-name-header" *ngIf="displayShortlisted">
                        <span class="stage-name-header-text" [pTooltip]="stage.name" tooltipPosition="bottom"
                            [showDelay]="300" [hideDelay]="0">{{ stage.name }}</span>
                        <span class="walkin-stage-tag" *ngIf="stage.is_walk_in">
                            <em class="pi pi-map-marker"></em> Walk-in
                        </span>
                    </div>
                    <div class="header-tabs-search-wrapper">
                        <div *ngIf="displayShortlisted" class="search-container">
                            <div class="stage-search">
                                <span class="p-input-icon-left">
                                    <em class="pi pi-search"></em>
                                    <input class="searchbar" type="text" [(ngModel)]="searchText"
                                        (input)="onSearchInputChange()" pInputText placeholder="Search Email" />
                                </span>
                            </div>
                        </div>
                        <div class="header-tabs">
                            <button class="tabs" [ngClass]="{'selected': displayShortlisted}"
                                (click)=" displayShortlisted = true; displayRuleEngine = false">Candidates</button>
                            <button
                                *ngIf="userPrivileges.has('event_stage_rule.view') || userPrivileges.has('event_stage_rule.create')"
                                class="tabs" [ngClass]="{'selected': displayRuleEngine}"
                                (click)="onRulesTabClick()">Stage Automation</button>

                        </div>
                    </div>
                </div>
                <div class="overflow-auto neo-scrollbar" *ngIf="displayRuleEngine">
                    <!-- Walk-in access: shared candidate URL + access key (Assessment walk-in stages only) -->
                    <div class="wa-panel" *ngIf="stage.is_walk_in">
                        <!-- Header band -->
                        <div class="wa-header">
                            <span class="wa-header-icon"><em class="pi pi-map-marker"></em></span>
                            <div class="wa-header-text">
                                <span class="wa-header-title">Walk-in access</span>
                                <span class="wa-header-sub">Share the link and announce the key to candidates at the venue.</span>
                            </div>
                        </div>

                        <!-- Credentials -->
                        <div class="wa-creds">
                            <div class="wa-card wa-card-link">
                                <span class="wa-card-label"><em class="pi pi-link"></em>Assessment link</span>
                                <div class="wa-input-row">
                                    <div class="wa-input">
                                        <span class="wa-value" [pTooltip]="getWalkInUrl(stage)" tooltipPosition="top">{{ getWalkInUrl(stage) }}</span>
                                    </div>
                                    <button type="button" class="wa-icon-box" (click)="copyWalkInValue(getWalkInUrl(stage), 'url')"
                                        [pTooltip]="copiedWalkInField === 'url' ? 'Copied' : 'Copy link'" tooltipPosition="top">
                                        <em class="pi" [ngClass]="copiedWalkInField === 'url' ? 'pi-check' : 'pi-copy'"></em>
                                    </button>
                                </div>
                            </div>

                            <div class="wa-card wa-card-key">
                                <div class="wa-key-top">
                                    <span class="wa-card-label wa-card-label-key"><em class="pi pi-key"></em>Access key</span>
                                    <button type="button" class="wa-regen-link" (click)="regenerateWalkInKey(stage)"
                                        [disabled]="regeneratingKeyStageId === stage.id">
                                        <em class="pi pi-sync"></em>{{ regeneratingKeyStageId === stage.id ? 'Regenerating…' : 'Regenerate' }}
                                    </button>
                                </div>
                                <div class="wa-input-row">
                                    <div class="wa-input">
                                        <span class="wa-value">{{ showWalkInKey ? stage.walk_in_key : maskedKey(stage.walk_in_key) }}</span>
                                        <button type="button" class="wa-in-btn" (click)="showWalkInKey = !showWalkInKey"
                                            [pTooltip]="showWalkInKey ? 'Hide key' : 'Show key'" tooltipPosition="top">
                                            <em class="pi" [ngClass]="showWalkInKey ? 'pi-eye-slash' : 'pi-eye'"></em>
                                        </button>
                                        <button type="button" class="wa-in-btn" (click)="copyWalkInValue(stage.walk_in_key, 'key')"
                                            [pTooltip]="copiedWalkInField === 'key' ? 'Copied' : 'Copy key'" tooltipPosition="top">
                                            <em class="pi" [ngClass]="copiedWalkInField === 'key' ? 'pi-check' : 'pi-copy'"></em>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Candidate flow -->
                        <div class="wa-steps">
                            <span class="wa-steps-label">What the candidate does</span>
                            <div class="wa-stepper">
                                <div class="wa-step">
                                    <span class="wa-step-n">01</span>
                                    <div class="wa-step-text">
                                        <span class="wa-step-title">Opens the link</span>
                                        <span class="wa-step-sub">and enters their email</span>
                                    </div>
                                </div>
                                <em class="pi pi-arrow-right wa-arrow"></em>
                                <div class="wa-step">
                                    <span class="wa-step-n">02</span>
                                    <div class="wa-step-text">
                                        <span class="wa-step-title">Enters the key</span>
                                        <span class="wa-step-sub">to verify access</span>
                                    </div>
                                </div>
                                <em class="pi pi-arrow-right wa-arrow"></em>
                                <div class="wa-step">
                                    <span class="wa-step-n">03</span>
                                    <div class="wa-step-text">
                                        <span class="wa-step-title">Launches</span>
                                        <span class="wa-step-sub">straight into the assessment</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p class="wa-note">Only candidates invited to this assessment can use this link and key. Regenerating the key will immediately invalidate the current one.</p>
                    </div>

                    <ng-container
                        *ngIf="stage.type == 'Assessment' || stage.type === 'Online Interview' || stage.type === 'Documentation' || stage.type === 'Offer' || stage.type === 'Offline Interview' || stage.type === 'AI Interview'">
                        <app-workflow-manage-schedule [stage]="stage" [eventStageFormData]="eventStageFormData"
                            (emitContestId)="contestId = $event"
                            (emitTestId)="testId = $event" (isStageUpdate)="getEventStages($event)">
                        </app-workflow-manage-schedule>
                    </ng-container>

                    <div class="stage-ruleSet">
                        <app-workflow-ruleset [stage]="stage" [allStages]="stages"></app-workflow-ruleset>
                    </div>
                </div>

                <ng-container *ngIf="displayShortlisted">
                    <app-stage-candidates [style]="{'height': '100%', 'display': 'flex'}"
                        [emailsCleared]="emailsCleared" [stage]="stage" [stages]="stages" [contestId]="contestId"
                        [initialStatus]="stage.id === deepLinkStageId ? deepLinkStatus : ''"
                        (emptyStage)="stage.deletable = $event" [search]="searchEmail" [testId]="testId"
                        (emailList)="emailList($event)" (candidateCount)="candidateCount($event)">
                    </app-stage-candidates>
                </ng-container>
            </div>
        </ng-content>
    </div>
    <p-toast></p-toast>
    <p-confirmpopup></p-confirmpopup>
</div>